<template>
  <div
    data-height="100"
    :class="classList"
    :style="styleList"
    v-on="$listeners"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import colorable from '../../mixins/colorable/colorable';
  import mixins from '../../mixins';

  export default mixins(colorable).extend({
    mixins: [colorable],
    props: {
      fillHeight: { default: false, type: Boolean },
      width: { default: undefined, type: [Number, String] },
      height: { default: undefined, type: [Number, String] },
      horizontal: { default: false, type: Boolean },
    },
    computed: {
      styleList() {
        return {
          ...this.getAllColors().style,
          width: this.width,
          height: this.height,
        };
      },
      classList() {
        return {
          'p-card': true,
          horizontal: this.horizontal,
          vertical: !this.horizontal,
          'fill-height': this.fillHeight,
          ...this.getAllColors().class,
        };
      },
    },
    // TODO: Get slot with p-img and set ratio?
    // Add prop to p-card and set default ratio there, pass along value to p-img
    // mounted() {
    //  const self = (this as any);
    //  self.$nextTick(() => {
    //    self.$nextTick(() => {
    //      const defaultSlot = self.$slots.default;
    //      debugger;
    //    });
    //  });
    // },
  });
</script>
